import React, { useState, useEffect } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AdminPage = () => {
  const [auth, setAuth] = useState(false);
  const [creds, setCreds] = useState({ username: '', password: '' });
  const [error, setError] = useState('');
  const [token, setToken] = useState('');
  const [data, setData] = useState(null);
  const [tab, setTab] = useState('manifesto');

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    try {
      const res = await axios.post(`${API}/admin/login`, creds);
      if (res.data.success) {
        setToken(res.data.token);
        setAuth(true);
      }
    } catch {
      setError('Credenziali non valide');
    }
  };

  useEffect(() => {
    if (auth && token) {
      axios.get(`${API}/admin/dashboard?token=${token}`).then(r => setData(r.data)).catch(() => {});
    }
  }, [auth, token]);

  if (!auth) {
    return (
      <main data-testid="admin-page" className="pt-24 min-h-screen flex items-center justify-center">
        <div className="max-w-md w-full mx-4">
          <div className="bg-[#0A0A0A] border border-[#00FF41]/30 p-8">
            <h1 className="text-2xl font-black text-[#00FF41] font-mono text-center mb-6">&lt;/ADMIN&gt;</h1>
            <form onSubmit={handleLogin} className="space-y-4">
              <div>
                <label className="block text-sm font-mono text-zinc-400 mb-2">Username</label>
                <input
                  type="text" required value={creds.username}
                  onChange={e => setCreds(p => ({ ...p, username: e.target.value }))}
                  className="w-full bg-black border border-white/20 text-white p-3 focus:border-[#00FF41] focus:outline-none font-mono"
                  data-testid="admin-username"
                />
              </div>
              <div>
                <label className="block text-sm font-mono text-zinc-400 mb-2">Password</label>
                <input
                  type="password" required value={creds.password}
                  onChange={e => setCreds(p => ({ ...p, password: e.target.value }))}
                  className="w-full bg-black border border-white/20 text-white p-3 focus:border-[#00FF41] focus:outline-none font-mono"
                  data-testid="admin-password"
                />
              </div>
              {error && <p className="text-red-500 text-sm text-center">{error}</p>}
              <button type="submit" className="w-full bg-[#00FF41] text-black font-bold py-3 hover:bg-[#33FF66] transition-colors" data-testid="admin-login-btn">
                ACCEDI
              </button>
            </form>
          </div>
        </div>
      </main>
    );
  }

  return (
    <main data-testid="admin-dashboard" className="pt-24 min-h-screen">
      <div className="max-w-6xl mx-auto px-6 py-8">
        <div className="flex items-center justify-between mb-8">
          <h1 className="text-3xl font-black text-[#00FF41] font-mono">&lt;/ADMIN DASHBOARD&gt;</h1>
          <button onClick={() => { setAuth(false); setToken(''); }} className="text-zinc-500 hover:text-white text-sm font-mono" data-testid="admin-logout">ESCI</button>
        </div>

        {/* Stats Cards */}
        {data && (
          <div className="grid md:grid-cols-3 gap-4 mb-8">
            <div className="bg-[#0A0A0A] border border-[#00FF41]/30 p-6 text-center">
              <p className="text-4xl font-black text-[#00FF41]">{data.total_donors}</p>
              <p className="text-zinc-400 text-sm mt-1">Donatori totali</p>
            </div>
            <div className="bg-[#0A0A0A] border border-[#00FF41]/30 p-6 text-center">
              <p className="text-4xl font-black text-[#00FF41]">{data.total_amount.toLocaleString()}€</p>
              <p className="text-zinc-400 text-sm mt-1">Totale raccolto</p>
            </div>
            <div className="bg-[#0A0A0A] border border-[#00FF41]/30 p-6 text-center">
              <p className="text-4xl font-black text-white">{Math.round(data.total_amount / data.goal * 100)}%</p>
              <p className="text-zinc-400 text-sm mt-1">Obiettivo €{data.goal.toLocaleString()}</p>
              <div className="h-2 bg-zinc-800 mt-3"><div className="h-full bg-[#00FF41]" style={{ width: `${Math.min(data.total_amount / data.goal * 100, 100)}%` }}></div></div>
            </div>
          </div>
        )}

        {/* Tabs */}
        <div className="flex gap-2 mb-6 border-b border-white/10 pb-2">
          {[
            { id: 'manifesto', label: 'Manifesto' },
            { id: 'pillole', label: 'Pillole Progetto' },
            { id: 'grafico', label: 'Simulazione AI' },
            { id: 'donatori', label: 'Donatori' },
          ].map(t => (
            <button key={t.id} onClick={() => setTab(t.id)}
              className={`px-4 py-2 font-mono text-sm transition-colors ${tab === t.id ? 'bg-[#00FF41] text-black font-bold' : 'text-zinc-400 hover:text-white'}`}
              data-testid={`admin-tab-${t.id}`}>
              {t.label}
            </button>
          ))}
        </div>

        {/* Tab Content */}
        {tab === 'manifesto' && (
          <div className="bg-[#0A0A0A] border border-white/10 p-8 prose prose-invert max-w-none" data-testid="admin-manifesto">
            <h2 className="text-2xl font-black text-[#00FF41] mb-6">EMAIL MANIFESTO</h2>
            <div className="text-zinc-300 leading-relaxed space-y-4">
              <p className="text-white font-bold text-lg">Oggetto: Invito a sostenere il primo Hub Sociale Digitale della Valdelsa</p>
              <hr className="border-white/10" />
              <p>Gentilissimo/a Dott./Dott.ssa <span className="text-[#00FF41]">[NOME]</span>,</p>
              <p>mi permetta di rubarLe pochi minuti del Suo prezioso tempo per presentarLe un progetto che potrebbe cambiare il volto della Valdelsa e, potenzialmente, dell'Italia intera.</p>
              <p>Mi chiamo Riccardo Rossi e sono il fondatore di <strong>A.I.C.O.A.</strong>, promotrice del progetto <strong className="text-[#00FF41]">&lt;/Ai_covo.tech&gt;®</strong>, il primo <strong>Hub Sociale Digitale</strong> pensato per i piccoli comuni italiani.</p>
              
              <h3 className="text-[#00FF41] text-xl font-bold mt-8">IL PROBLEMA</h3>
              <p>In Italia, 5.500 comuni sotto i 30.000 abitanti condividono la stessa emergenza silenziosa:</p>
              <ul className="list-disc pl-6 space-y-1">
                <li><strong>Anziani</strong> che non sanno accedere allo SPID né ai servizi digitali della PA</li>
                <li><strong>Giovani</strong> connessi ma "sconnessi" — dipendenti dai social, privi di spazi</li>
                <li><strong>Immigrati</strong> emarginati, senza punti di riferimento</li>
                <li><strong>Famiglie</strong> senza doposcuola accessibile né formazione digitale</li>
                <li><strong>Persone in difficoltà</strong> invisibili alle istituzioni</li>
              </ul>

              <h3 className="text-[#00FF41] text-xl font-bold mt-8">LA SOLUZIONE: AI_COVO</h3>
              <ul className="list-disc pl-6 space-y-1">
                <li>Doposcuola gratuito per bambini e ragazzi</li>
                <li>Formazione digitale per anziani e adulti (SPID, PEC, home banking)</li>
                <li>Academy per giovani (programmazione, design, imprenditoria)</li>
                <li>Sportello di ascolto per immigrati e persone in difficoltà</li>
                <li>Spazi pubblici di co-working e aggregazione sociale</li>
              </ul>

              <h3 className="text-[#00FF41] text-xl font-bold mt-8">I NUMERI</h3>
              <p>Simulazione su <strong>30.000 abitanti della Valdelsa</strong>:</p>
              <ul className="list-disc pl-6 space-y-1">
                <li>8.687 visitano il sito (29%)</li>
                <li>2.495 cliccano per approfondire (8,3%)</li>
                <li>1.038 chiedono informazioni (3,5%)</li>
                <li>382 donano tramite crowdfunding (1,3%)</li>
                <li><strong className="text-[#00FF41]">~€8.500 raccolti</strong> dal solo crowdfunding</li>
              </ul>
              <p className="text-red-400 font-bold">Il crowdfunding copre solo il 12% del fabbisogno. Per questo ci rivolgiamo a Lei.</p>

              <h3 className="text-[#00FF41] text-xl font-bold mt-8">DI COSA ABBIAMO BISOGNO</h3>
              <p>Budget primo anno: <strong className="text-[#00FF41]">€88.750</strong></p>

              <hr className="border-white/10" />
              <p className="text-zinc-400 italic">Per informazioni: <a href="mailto:riccardorossi1984@gmail.com" className="text-[#00FF41] hover:underline">riccardorossi1984@gmail.com</a> | <a href="https://wa.me/393273839782" className="text-[#00FF41] hover:underline" target="_blank" rel="noopener noreferrer">WhatsApp +39 327 383 9782</a></p>
            </div>
          </div>
        )}

        {tab === 'pillole' && (
          <div className="bg-[#0A0A0A] border border-white/10 p-8" data-testid="admin-pillole">
            <h2 className="text-2xl font-black text-[#00FF41] mb-6">PILLOLE DEL PROGETTO</h2>
            <div className="grid md:grid-cols-2 gap-6">
              <div className="border border-[#00FF41]/20 p-6">
                <p className="text-[#00FF41] font-mono text-xs uppercase mb-2">CHI SIAMO</p>
                <p className="text-white font-bold mb-2">A.I.C.O.A. — Associazione Culturale</p>
                <p className="text-zinc-400 text-sm">Prima associazione culturale a Colle Val d'Elsa dedicata all'inclusione sociale attraverso il digitale.</p>
              </div>
              <div className="border border-[#00FF41]/20 p-6">
                <p className="text-[#00FF41] font-mono text-xs uppercase mb-2">COSA FACCIAMO</p>
                <p className="text-white font-bold mb-2">Hub Fisico + Digitale</p>
                <p className="text-zinc-400 text-sm">Doposcuola, formazione digitale, academy giovani, sportello ascolto, spazi pubblici.</p>
              </div>
              <div className="border border-[#00FF41]/20 p-6">
                <p className="text-[#00FF41] font-mono text-xs uppercase mb-2">VISIONE</p>
                <p className="text-white font-bold mb-2">Primo Comune Inclusivo d'Italia</p>
                <p className="text-zinc-400 text-sm">Modello replicabile proposto all'ANCI per ogni comune sotto 30.000 abitanti.</p>
              </div>
              <div className="border border-[#00FF41]/20 p-6">
                <p className="text-[#00FF41] font-mono text-xs uppercase mb-2">CROWDFUNDING</p>
                <p className="text-white font-bold mb-2">Sistema "Cinture di Karate"</p>
                <p className="text-zinc-400 text-sm">Da 1€ (Badge) a 999€ (Sponsor Aziendale). 7 livelli gamificati con premi fisici.</p>
              </div>
              <div className="border border-[#00FF41]/20 p-6">
                <p className="text-[#00FF41] font-mono text-xs uppercase mb-2">BUDGET</p>
                <p className="text-white font-bold mb-2">€88.750 — Anno 1</p>
                <p className="text-zinc-400 text-sm">12% crowdfunding, 88% fondi istituzionali (fondazioni, regione, PNRR, comuni).</p>
              </div>
              <div className="border border-[#00FF41]/20 p-6">
                <p className="text-[#00FF41] font-mono text-xs uppercase mb-2">DEDUCIBILITÀ</p>
                <p className="text-white font-bold mb-2">100% per le aziende</p>
                <p className="text-zinc-400 text-sm">Art. 100 comma 2 TUIR — erogazioni liberali ad associazioni culturali interamente deducibili.</p>
              </div>
            </div>
          </div>
        )}

        {tab === 'grafico' && (
          <div className="bg-[#0A0A0A] border border-white/10 p-8" data-testid="admin-grafico">
            <h2 className="text-2xl font-black text-[#00FF41] mb-6">SIMULAZIONE AI — 30.000 ABITANTI</h2>
            <img src="/grafico_finanziamento.png" alt="Piano di Finanziamento €88.750" className="w-full rounded-lg mb-8" />
            
            <h3 className="text-lg font-bold text-white mb-4">Funnel Conversione (Simulazione)</h3>
            <div className="space-y-3">
              {[
                { label: 'Popolazione', value: '30.000', pct: 100, color: 'bg-zinc-600' },
                { label: 'Accesso internet', value: '20.025', pct: 66.8, color: 'bg-zinc-500' },
                { label: 'Visitano il sito', value: '8.687', pct: 29, color: 'bg-blue-500' },
                { label: 'Cliccano CTA', value: '2.495', pct: 8.3, color: 'bg-yellow-500' },
                { label: 'Chiedono info', value: '1.038', pct: 3.5, color: 'bg-orange-500' },
                { label: 'Donano', value: '382', pct: 1.3, color: 'bg-[#00FF41]' },
              ].map((row, i) => (
                <div key={i} className="flex items-center gap-4">
                  <span className="text-zinc-400 text-sm w-40">{row.label}</span>
                  <div className="flex-1 h-6 bg-zinc-800 overflow-hidden">
                    <div className={`h-full ${row.color} transition-all`} style={{ width: `${row.pct}%` }}></div>
                  </div>
                  <span className="text-white font-mono text-sm w-20 text-right">{row.value}</span>
                  <span className="text-zinc-500 text-xs w-12 text-right">{row.pct}%</span>
                </div>
              ))}
            </div>

            {data && data.belt_breakdown.length > 0 && (
              <div className="mt-8">
                <h3 className="text-lg font-bold text-white mb-4">Donazioni per Cintura</h3>
                <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
                  {data.belt_breakdown.map((b, i) => (
                    <div key={i} className="bg-black/50 border border-white/10 p-4 text-center">
                      <p className="text-[#00FF41] font-bold text-lg">{b.count}</p>
                      <p className="text-zinc-400 text-xs">{b.belt}</p>
                      <p className="text-white font-mono text-sm">{b.total.toLocaleString()}€</p>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {data && data.demo_breakdown.length > 0 && (
              <div className="mt-8">
                <h3 className="text-lg font-bold text-white mb-4">Donazioni per Fascia Demografica</h3>
                <div className="space-y-2">
                  {data.demo_breakdown.map((d, i) => (
                    <div key={i} className="flex items-center gap-4 bg-black/30 p-3">
                      <span className="text-zinc-300 text-sm flex-1">{d.demo}</span>
                      <span className="text-[#00FF41] font-mono font-bold">{d.count} donatori</span>
                      <span className="text-white font-mono">{d.total.toLocaleString()}€</span>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        )}

        {tab === 'donatori' && data && (
          <div className="bg-[#0A0A0A] border border-white/10 p-8" data-testid="admin-donatori">
            <h2 className="text-2xl font-black text-[#00FF41] mb-6">ULTIMI DONATORI</h2>
            <div className="space-y-2">
              {data.recent_donors.map((d, i) => (
                <div key={i} className="flex items-center gap-4 bg-black/30 border border-white/5 p-4">
                  <span className="text-white font-bold flex-1">{d.name}</span>
                  {d.company_name && <span className="text-emerald-400 text-xs">{d.company_name}</span>}
                  <span className="text-zinc-400 text-sm">{d.comune}</span>
                  <span className="text-[#00FF41] font-mono font-bold">{d.amount}€</span>
                  <span className="text-zinc-500 text-xs">{d.belt}</span>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Quick Links */}
        <div className="mt-8 bg-[#0A0A0A] border border-white/10 p-6">
          <p className="text-[#00FF41] font-mono text-xs uppercase mb-3">Link Rapidi</p>
          <div className="flex flex-wrap gap-3">
            <a href="mailto:riccardorossi1984@gmail.com" className="text-[#00FF41] hover:underline text-sm" target="_blank" rel="noopener noreferrer">Email Info</a>
            <a href="https://wa.me/393273839782" className="text-[#00FF41] hover:underline text-sm" target="_blank" rel="noopener noreferrer">WhatsApp</a>
            <a href="/grafico_finanziamento.png" className="text-[#00FF41] hover:underline text-sm" target="_blank" rel="noopener noreferrer">Scarica Grafico</a>
            <a href="/dona" className="text-[#00FF41] hover:underline text-sm">Pagina Donazioni</a>
            <a href="/tshirt" className="text-[#00FF41] hover:underline text-sm">Premi/Cinture</a>
          </div>
        </div>
      </div>
    </main>
  );
};

export default AdminPage;
